import MUIRichTextEditor from 'mui-rte';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AbbottTheme } from '@abbott-components/core';
import customControlList from './customControls';
import getCustomThemeEntry from './getCustomThemeEntry';

export default ({
  width,
  initialValue,
  showPlaceholder
}: {
  width: string | number;
  initialValue: string;
  showPlaceholder: boolean;
}) => {
  const defaultTheme = createTheme(AbbottTheme);

  return (
    <ThemeProvider
      theme={{
        ...defaultTheme,
        ...getCustomThemeEntry(width as string)
      }}
    >
      <MUIRichTextEditor
        label={showPlaceholder ? 'Type something here...' : ''}
        readOnly={true}
        defaultValue={initialValue}
        controls={[]}
        customControls={customControlList}
      />
    </ThemeProvider>
  );
};
